<template>
  <div>
    <!--
      Previous inline preview logic (replaced by TopicMediaPreview):
      <div v-if="selectedTopic.docType == 'pdf' && selectedTopic.length != 0">
        <iframe
          v-if="pdfUrl"
          class="screenht450 w-full -mt-4"
          :src="pdfUrl"
          frameborder="0"
          height="600"
          width="100%"
        ></iframe>
      </div>
      <div
        v-else-if="selectedTopic.docType == 'video' && selectedTopic.length != 0"
      >
        <video
          width="100%"
          height="450"
          controls
          autoplay
          controlsList="nodownload"
          class="h400"
          :src="video"
        >
          Your browser does not support the video tag.
        </video>
      </div>
      <div v-else>
        <video width="100%" height="100%" controls autoplay controlsList="nodownload">
          <source src="movie.ogg" type="video/ogg" />
          Your browser does not support the video tag.
        </video>
      </div>
    -->
    <TopicMediaPreview
      v-if="hasTopicMedia"
      :doc-path="selectedTopic.docPath"
      :doc-type="selectedTopic.docType"
      video-class="h400"
      :video-height="'450'"
      :iframe-height="600"
    />
  </div>
</template>
<script>
import TopicMediaPreview from "@/components/TopicMediaPreview.vue";
// Previous import:
// import { buildMediaUrl, buildPdfPreviewUrl } from "@/utils/mediaUrl";

export default {
  components: {
    TopicMediaPreview,
  },
  props: {
    selectedTopic: {
      type: Object,
    },
  },
  computed: {
    hasTopicMedia() {
      return (
        this.selectedTopic?.docPath &&
        Object.keys(this.selectedTopic).length !== 0 &&
        (this.selectedTopic.docType === "pdf" ||
          this.selectedTopic.docType === "video")
      );
    },
    // Previous computed preview URLs (replaced by TopicMediaPreview):
    // video() {
    //   return buildMediaUrl(this.selectedTopic?.docPath, this.$imageURL);
    // },
    // pdfUrl() {
    //   return buildPdfPreviewUrl(this.selectedTopic?.docPath, this.$imageURL);
    // },
  },
};
</script>
